import {firstOrUndefined} from "@ots-frontend/ots-data";
import {InsightEmpty} from "../InsightEmpty/InsightEmpty";
import {InsightBarChart, InsightBarChartProps} from "../InsightBarChart/InsightBarChart";
import {StatisticTypeSelect} from "../../select/entity/StatisticTypeSelect/StatisticTypeSelect";
import {Center, Stack} from "@mantine/core";
import {ByTimeInsightProps} from "./ByTimeInsight";
import {useByTimeInsight} from "./useByTimeInsight";
import {PropsWithChildren} from "react";

export type BarByTimeInsightProps =
  Pick<InsightBarChartProps, 'tooltipPos' | 'stacked' | 'containerProps' | 'loading'>
  & ByTimeInsightProps

export const BarByTimeInsight = (props: PropsWithChildren<BarByTimeInsightProps>) => {
  const {
    title,
    fromDttm,
    toDttm = new Date().getTime(),
    data,
    methods,
    splitMethod = true,
    statisticsTypes,
    category,
    showSelect = true,
    showEmpty = true,
    children,
    ...rest
  } = props

  const {
    chartData,
    types,
    statisticType,
    setStatisticType
  } = useByTimeInsight({
    fromDttm,
    toDttm,
    data,
    methods,
    splitMethod,
    statisticsTypes,
    category,
  })

  if (showEmpty && (!chartData || chartData.titles.length === 0)) {
    return (
      <InsightEmpty {...rest} title={title}>
        {children}
      </InsightEmpty>
    )
  }

  return (
    // @ts-ignore
    <InsightBarChart
      {...rest}
      title={title}
      data={chartData}>
      {((showSelect && types.length > 1) || children) &&
        <Stack>
          {(showSelect && types.length > 1) &&
            <Center>
              <StatisticTypeSelect
                w={"250px"}
                placeholder={"Type"}
                defaultValue={statisticType}
                options={types}
                onDbCodeChange={c => setStatisticType(firstOrUndefined(c))}/>
            </Center>
          }
          {children}
        </Stack>
      }
    </InsightBarChart>
  )
}
